import { useState } from "react";
import { Link } from "@/lib/router-compat";
import logo from "@/assets/logo-new-final.png";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import ContactForm from "@/components/ContactForm";

const Footer = () => {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <footer className="border-t border-border bg-card py-10">
      <div className="container mx-auto px-4 lg:px-8">
        <Dialog open={contactOpen} onOpenChange={setContactOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle>Get in touch</DialogTitle>
            </DialogHeader>
            <ContactForm />
            <p className="text-xs text-muted-foreground">
              Employer, partner or press?{" "}
              <Link to="/contact" onClick={() => setContactOpen(false)} className="font-semibold text-primary hover:underline">Visit our Contact page</Link>
            </p>
          </DialogContent>
        </Dialog>

        <div className="flex flex-col items-center gap-6 md:flex-row md:justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} alt="Home Approach" width={1904} height={1920} className="h-20 w-auto" />
          </Link>
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-muted-foreground" aria-label="Footer navigation">
            <Link to="/blog" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">Blog</Link>
            <Link to="/guides" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">Free Guides</Link>
            <Link to="/homebuying-support" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">Homebuying Support</Link>
            <Link to="/mortgage-glossary" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">Mortgage Glossary</Link>
            <Link to="/grant-finder" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">Stack</Link>
            <Link to="/our-promise" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">Our Promise</Link>
            <Link to="/how-we-make-money" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">How We Make Money</Link>
            <Link to="/about" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">About Us</Link>
            <Link to="/lp/organizations" className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center">For Employers</Link>
            <button onClick={() => setContactOpen(true)} className="hover:text-brand transition-colors py-1.5 min-h-[44px] flex items-center text-sm">Contact Us</button>
          </nav>
          <div className="flex flex-col items-center gap-3 md:items-end">
            <div className="flex gap-4 text-xs text-muted-foreground">
              <Link to="/privacy-policy" className="hover:text-foreground transition-colors py-1.5 min-h-[44px] flex items-center">Privacy Policy</Link>
              <Link to="/terms-and-conditions" className="hover:text-foreground transition-colors py-1.5 min-h-[44px] flex items-center">Terms &amp; Conditions</Link>
            </div>
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} Home Approach. All rights reserved.
            </p>
            {/* Pixabay free-tier terms require attribution wherever their search
                results are displayed (https://pixabay.com/api/docs/) — this app
                auto-embeds one chosen photo per article rather than showing a
                gallery, so a standing site-wide credit satisfies that rather
                than a per-image caption in every generated post's markdown. */}
            <p className="text-xs text-muted-foreground/70">
              Some images courtesy of{" "}
              <a href="https://pixabay.com" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">
                Pixabay
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
